import React, { useEffect, useState } from "react";

import './ProgramacionMasiva.scss'
import InputLista from "../../../components/atoms/InputLista/InputLista";
import Button from "../../../components/atoms/Button/Button";
import TitleView from "../../../components/atoms/TitleView/TitleView";
import { getClients } from "../../monitoreo/MonitoreoServicios/MonitoreoServiciosIntegracion";
import InputCalendario from "../../../components/atoms/InputCalendario/InputCalendario";
import { extraerHora, formateoBasico, obtenerHoraAmPm } from "../../../utilities/formateos";
import Swal from "sweetalert2";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { getEstructuras, programacionMasivaPorEstrucutura } from "./ProgramacionMasivaIntegracion";
import { Dropdown } from "primereact/dropdown";


const ProgramacionMasiva = () => {
    const [clientes, setClientes] = useState([])
    const [cliente, setCliente] = useState(null)
    const [estructuras, setEstructura] = useState([])

    //años
    const [anio, setAnio] = useState(new Date().getFullYear()); // Estado para el año
    const [semanas, setSemanas] = useState([]);
    const [semana, setSemana] = useState(null);

    const [estructurasFaltantes, setEstructurasFaltantes] = useState([]);



    useEffect(() => {
        getClients(setClientes)
        let semanas = []
        for (let i = 1; i <= 52; i++) {
            semanas.push({ name: i, code: i })
        }
        setSemanas(semanas)
    }, [])
    useEffect(() => {
        if (cliente) {

            getEstructuras(setEstructura, cliente.code, anio)

        }
    }, [cliente, anio])
    useEffect(() => {
        if (estructuras) {

            const estructurasSinBitacoras = estructuras.filter(item => item.NUMERO_BITACORAS === 0);
            setEstructurasFaltantes(estructurasSinBitacoras)
        }
    }, [estructuras])

    const handleClick = async () => {
        if (cliente?.code) {
            const estructurasSinBitacoras = estructuras.filter(item => item.NUMERO_BITACORAS === 0);
            setEstructurasFaltantes(estructurasSinBitacoras)
            for (let i = 0; i <= estructurasSinBitacoras.length - 1; i++) {
                await programacionMasivaPorEstrucutura(cliente.code, anio, semana.code, estructurasSinBitacoras[i].ID_ESTRUCTURA, estructurasSinBitacoras[i].RUTA)
                await getEstructuras(setEstructura, cliente.code, anio)

            }

            // Swal.fire({
            //     icon: 'success',   // Icono de error
            //     title: 'Registrado correctamente', // Título de la alerta
            // });
        }
        else {
            Swal.fire({
                icon: "error",
                text: "Todos los campos deven ser obligatorios"

            });
        }
    }




    // Manejar el cambio del año
    const handleYearChange = (e) => {
        const inputYear = parseInt(e.target.value, 10);
        if (!isNaN(inputYear)) {
            setAnio(inputYear);
        }
    };
    const ProgressBar = ({ total, remaining }) => {
        // Calculamos el porcentaje de progreso
        const progress = ((total - remaining) / total) * 100;

        return (
            <div style={{ width: '100%', height: '20px', backgroundColor: '#f3f3f3', borderRadius: '5px', color: "white" }}>
                <div
                    style={{
                        textAlign: 'center',
                        width: `${progress}%`,
                        height: '100%',
                        backgroundColor: progress === 100 ? 'green' : '#063970',
                        borderRadius: '5px',
                    }}
                >{Math.round(progress)}%</div>
            </div>
        );
    };

    return (
        <div className="ProgramacionMasiva">
            <TitleView title={"Programacion masiva"}></TitleView>
            <div className="contenedor-de-opciones">
                <InputLista placeholder={"Selecciona un cliente"} options={clientes} onChange={(e) => { setCliente(e.value) }} value={cliente} className={"select"} titulo={"Selecciona el cliente"} obligatory={false}></InputLista>
                <InputCalendario value={anio} className={"calendario"} titulo={"Selecciona en año a programar"} type="number" onChange={(e) => { handleYearChange(e) }}></InputCalendario>
                <InputLista placeholder={"Selecciona una semana"} options={semanas} onChange={(e) => { setSemana(e.value) }} value={semana} className={"select"} titulo={"Selecciona una semana"} obligatory={false}></InputLista>

                <Button className={"button"} onClick={() => { handleClick() }}>Programar</Button>


                <DataTable
                    value={estructuras}
                    header={
                        <>
                        <div className="total-resto">
                            <div className="total">Total : {estructuras.length}</div>
                            <div className="resto">Restante : {estructurasFaltantes.length}</div>
                        </div>
                            <ProgressBar total={estructuras.length} remaining={estructurasFaltantes.length}></ProgressBar>
                        </>
                    }
                >
                    <Column field="ID_TR_BITACORA" header="ID_ESTRUCTURA" body={(rowData) => <td data-label="ID_ESTRUCTURA">{rowData.ID_ESTRUCTURA}</td>} />
                    <Column field="FECHA" header="ID_RUTA" body={(rowData) => <td data-label="ID_RUTA">{rowData.ID_RUTA}</td>} />
                    <Column field="NOMBRE_TR_RUTA" header="RUTA" body={(rowData) => <td data-label="RUTA">{rowData.RUTA}</td>} />
                    <Column field="CONFIRMADA" header="HORA_INICIO" body={(rowData) => <td data-label="HORA_INICIO">{extraerHora(rowData.HORA_INICIO)}</td>} />
                    <Column field="CONFIRMADA" header="HORA_FIN" body={(rowData) => <td data-label="HORA_FIN">{extraerHora(rowData.HORA_FIN)}</td>} />
                    <Column field="PAGAR" header="BITACORAS" body={(rowData) => <td data-label="NUMERO_BITACORAS">{rowData.NUMERO_BITACORAS}</td>} />
                    <Column field="PAGAR" header="PROGRAMADO" body={(rowData) => <td data-label="PAGAR">{rowData.NUMERO_BITACORAS !== 0 ? "✅" : "🚫"}</td>} />
                </DataTable>

                <div className="estructuras_faltantes">
                    {
                        estructurasFaltantes?.map((item,key)=>{
                            return(
                                <>
                                <div>
                                   {key+1}. {item.RUTA} - ID_RUTA: {item.ID_ESTRUCTURA}
                                </div>
                                </>
                            )
                        })
                    }
                </div>





            </div>
        </div>
    )
}
export default ProgramacionMasiva